let locks = 0;
let restore = null;

// Share one lock when a quick view hands over to another dialog.
export function lockBodyScroll() {
  if (locks++ === 0) {
    const body = document.body;
    const root = document.documentElement;
    const saved = Object.fromEntries(["overflow", "position", "top", "left", "width", "paddingRight"].map((key) => [key, body.style[key]]));
    const x = window.scrollX;
    const y = window.scrollY;
    const url = window.location.href;
    const touch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
    const gap = Math.max(0, window.innerWidth - root.clientWidth);
    body.style.overflow = "hidden";
    if (touch) {
      Object.assign(body.style, { position: "fixed", top: `-${y}px`, left: `-${x}px`, width: "100%" });
    } else if (gap) {
      body.style.paddingRight = `${(parseFloat(getComputedStyle(body).paddingRight) || 0) + gap}px`;
    }
    root.setAttribute("data-dialog-open", "true");
    window.__lenis?.stop();
    restore = () => {
      Object.assign(body.style, saved);
      root.removeAttribute("data-dialog-open");
      window.__lenis?.start();
      if (touch && window.location.href === url) window.scrollTo(x, y);
    };
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--locks === 0) { restore?.(); restore = null; }
  };
}
